<template>
  <div class="header">
    <div class="top_title">
      <div class="wrap clear">
        <span class="fl">您好，欢迎来到广电计量供应商门户网站</span>
        <span class="fr">
          <span v-if="login">
            <span>用户名username ｜</span>
            <span>退出 ｜</span>
            <span>会员中心 ｜</span>
          </span>
        </span>
      </div>
    </div>
    <div class="header_content">
      <div class="wrap">
        <div class="logo"><img src="@/assets/img/logo.png" alt="logo" @click.stop="goIndex" /></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: false
    }
  },
  mounted() {},
  methods: {
    goIndex() {
      this.$router.push('/')
    }
  }
}
</script>
<style scoped lang="scss">
.top_title {
  color: #999;
  text-indent: 4px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #cccccc;
}
.header_content {
  display: flex;
  align-items: center;
  padding: 38px 0;
  .logo {
    flex: 1;
    img {
      cursor: pointer;
    }
  }
}
.title_bar {
  background-color: #054c81;
}
.title_bar ::v-deep .el-menu {
  border-bottom: none;
  .el-menu-item {
    font-size: 16px;
    padding: 0 40px;
    height: 50px;
    line-height: 50px;
  }
}
.title_bar ::v-deep .el-menu-item.is-active {
  background-color: #0774c5 !important;
  border-bottom: none !important;
}
</style>
